import { createFileRoute } from '@tanstack/react-router';
import { ReportBuilderPage } from '../../features/reports/builder/ReportBuilderPage.jsx';

function EditReportRoute() {
  const { reportId } = Route.useParams();
  return <ReportBuilderPage key={reportId} reportId={reportId} />;
}

export const Route = createFileRoute('/_app/reports/$reportId/edit')({ component: EditReportRoute });
